var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gameplay_title_container"},[_c('div',{staticClass:"gameplay_title"},[_vm._v("\n      "+_vm._s(_vm.getTranslations.home_game_memory_attention_question)+"      ")])]),_vm._v(" "),_c('div',{staticClass:"gameplay_game_box memory6"},[_c('img',{attrs:{"src":_vm.gameInfo.img},on:{"load":_vm.loadImage}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4076db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/memory/MemoryAttention.vue
// module id = null
// module chunks = 